export default "__VITE_ASSET__ljmuVx$q__"